import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-[#0E1A57] text-[#eeb934]'>
          <div className=' container mx-auto p-4'>
                <p className='text-center font-bold' title="Youtube Channel"> Welcome to Claynest</p>
           
          </div>
      
    </footer>
  )
}

export default Footer